import React from "react";
import LegalShell from "../../components/LegalShell";

const HISTORY = [
    {
        version: "2026-02-26",
        date: "February 26, 2026",
        changes: [
            "Added explicit references to state age-verification statutes (UT, LA, TX, AR, MS, MT, NC, VA, ID).",
            "Clarified Stripe Connect creator-payout terms (15% platform fee, minimum $10, 2-day rolling).",
            "Introduced per-state privacy sections: CCPA/CPRA, VCDPA, CPA, CTDPA, UCPA, TDPSA, OCPA, MCDPA, ICDPA, DPDPA, NRS 603A.",
            "Added GDPR/UK-GDPR/FADP + LGPD sections.",
            "Introduced the community reporting flow and auto-flag threshold (3 open reports).",
        ],
    },
    {
        version: "2026-02-01",
        date: "February 1, 2026",
        changes: [
            "Initial launch of footsie Terms of Service, Privacy Policy, DMCA Policy, Community Guidelines, and Disclaimer.",
            "Established the strictly SFW policy and 18+ adult-user requirement.",
            "Defined subscription and one-time purchase terms via Stripe.",
        ],
    },
];

export default function Changelog() {
    return (
        <LegalShell title="Terms Changelog" tagline="Every version of our legal docs, listed clearly. No surprises." testId="page-changelog">
            <p>
                We keep a public record of every material change to our Terms of Service, Privacy Policy, and related documents.
                When we bump the version, all active users are asked to re-accept before continuing to use footsie.
            </p>
            <ul className="space-y-6 not-prose">
                {HISTORY.map((entry) => (
                    <li key={entry.version} className="brut-inset bg-[#FFFDF7] rounded-lg p-4">
                        <div className="flex items-baseline gap-3 mb-2">
                            <div className="display text-2xl font-black">{entry.version}</div>
                            <div className="text-xs font-medium text-[#4A4A4A]">{entry.date}</div>
                        </div>
                        <ul className="list-disc pl-5 space-y-1 text-sm font-medium">
                            {entry.changes.map((c) => <li key={c}>{c}</li>)}
                        </ul>
                    </li>
                ))}
            </ul>
        </LegalShell>
    );
}
